import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Landing from '../views/Landing.vue'
import ContactUs from '../views/ContactUs.vue'
import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Landing',
    components: {
      header: Navbar,
      default: Landing,
      footer: Footer
    },
    alias: '/index'
  },
  {
    path: '/contact-us',
    name: 'ContactUs',
    components: {
      header: Navbar,
      default: ContactUs,
      footer: Footer
    }
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes

})

export default router
